export default {"src":"/_next/static/media/close-icon.76e4372f.svg","height":16,"width":16};